import { render, staticRenderFns } from "./lsh.vue?vue&type=template&id=dee10da4&scoped=true"
import script from "./lsh.vue?vue&type=script&lang=js"
export * from "./lsh.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dee10da4",
  null
  
)

export default component.exports